import { useEffect, useMemo, useState } from 'react';

const baseColumns = [
  { key: 'numero', label: 'Número' },
  { key: 'cliente', label: 'Cliente / referencia' },
  { key: 'sucursal', label: 'Sucursal' },
  { key: 'estado', label: 'Estado' },
  { key: 'fecha', label: 'Fecha' },
];

const formatValue = (value) => {
  if (value == null || value === '') return '—';
  return value;
};

export default function DetalleOperativoTable({
  rows = [],
  extraColumns = [],
  pageSize = 10,
  emptyMessage = 'Sin registros para este criterio.',
}) {
  const [page, setPage] = useState(1);

  useEffect(() => {
    setPage(1);
  }, [rows, pageSize]);

  const columns = useMemo(() => [...baseColumns, ...extraColumns], [extraColumns]);
  const totalPages = Math.max(1, Math.ceil(rows.length / pageSize));
  const currentPage = Math.min(page, totalPages);
  const start = (currentPage - 1) * pageSize;
  const visibleRows = rows.slice(start, start + pageSize);

  return (
    <div className="rounded-2xl border border-[rgba(var(--border),0.6)] bg-[rgb(var(--panel))] shadow-[0_16px_36px_rgba(var(--shadow),0.12)]">
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm text-[rgba(var(--fg),0.82)]">
          <thead className="bg-[rgba(var(--panel),0.72)] text-[11px] uppercase tracking-[0.14em] text-[rgb(var(--muted))]">
            <tr>
              {columns.map((column) => (
                <th key={column.key} className="px-3 py-2.5 text-left font-semibold">
                  {column.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {visibleRows.length === 0 ? (
              <tr>
                <td colSpan={columns.length} className="px-3 py-8 text-center text-[rgb(var(--muted))]">
                  {emptyMessage}
                </td>
              </tr>
            ) : (
              visibleRows.map((row) => (
                <tr key={`${row.id}-${row.numero}-${row.estado}`} className="border-t border-[rgba(var(--border),0.48)]">
                  {columns.map((column) => (
                    <td key={`${row.id}-${column.key}`} className="px-3 py-2.5 align-top break-words">
                      {formatValue(row[column.key])}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="flex flex-wrap items-center justify-between gap-2 border-t border-[rgba(var(--border),0.48)] px-3 py-2.5 text-sm text-[rgb(var(--muted))]">
        <span>
          {rows.length === 0 ? '0 resultados' : `${start + 1}-${Math.min(start + pageSize, rows.length)} de ${rows.length}`}
        </span>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => setPage((value) => Math.max(1, value - 1))}
            disabled={currentPage === 1}
            className="rounded-full border border-[rgba(var(--border),0.7)] px-3 py-1.5 disabled:cursor-not-allowed disabled:opacity-45"
          >
            Anterior
          </button>
          <span>{currentPage} / {totalPages}</span>
          <button
            type="button"
            onClick={() => setPage((value) => Math.min(totalPages, value + 1))}
            disabled={currentPage === totalPages}
            className="rounded-full border border-[rgba(var(--border),0.7)] px-3 py-1.5 disabled:cursor-not-allowed disabled:opacity-45"
          >
            Siguiente
          </button>
        </div>
      </div>
    </div>
  );
}
